<template>
    <div>
        <h4 class="bg-success p-3 rounded text-white text-center fw-bold">{{$t('Family Information')}}</h4>
        <div class="row mt-5">
            <!--            TODO: here is my spouse info start-->
            <div class="spouse-main border-3">
                <div v-for="(spouse, index) in spouseInfo" :key="index" class="row">
                    <div class="col-md-6">
                        <b-form-group label="Spouse Name" label-cols="3" label-for="spouseName">
                            <b-form-input
                                    v-model="spouseInfo[index].spouseName"
                                    type="text"
                                    :state="getInputState(spouseInfo[index].spouseName)"
                                    placeholder="Spouse Name">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="showError(spouseInfo[index].spouseName)">
                                Spouse Name is required.
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group label="Profession" label-cols="3" label-for="profession">
                            <b-form-select
                                    v-model="spouseInfo[index].professionId"
                                    :state="getInputState(spouseInfo[index].professionId)"
                                    :options="professionOption"
                                    text-field="profession"
                                    value-field="professionId"

                            >
                                <option :value="null" selected>-- Select One --</option>
                                <b-form-invalid-feedback v-if="showError(spouseInfo[index].professionId)">
                                    Profession name is required.
                                </b-form-invalid-feedback>
                            </b-form-select>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group label="Nationality" label-cols="3" label-for="nationality">
                            <b-form-select
                                    v-model="spouseInfo[index].nationalityId"
                                    :state="getInputState(spouseInfo[index].nationalityId)"
                                    :options="nationalityOptions"
                                    text-field="country"
                                    value-field="countryId">
                                <option :value="null" selected>-- Select One --</option>
                                <b-form-invalid-feedback v-if="showError(spouseInfo[index].nationalityId)">
                                    Nationality name is required.
                                </b-form-invalid-feedback>
                            </b-form-select>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group label="NID/Passport No" label-cols="3">
                            <b-form-input
                                    v-model="spouseInfo[index].nid"
                                    :state="getInputState(spouseInfo[index].nid)"
                                    placeholder="NID/Passport No">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="showError(spouseInfo[index].nid)">
                                Nid name is required.
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>

                    <div class="col-md-6" v-if="spouse.nid">
                        <b-form-group label="NID/Passport Document" label-cols="3">
                            <div class="d-flex align-items-center">
                                <input
                                        type="file"
                                        @change="spouseInfoNid(index, $event)"
                                        class="form-control form-control-md me-2"
                                        style="width: 90%;"/>
                                <button
                                        class="btn btn-success"
                                        @click="downloadFile(spouseInfo[index].nidPaperUrl, 'Spouse Nid')"
                                        v-if="spouseInfo[index].nidPaperUrl"
                                        style="white-space: nowrap;">
                                    <font-awesome-icon class="text-white" :icon="['fas', 'download']"/>
                                </button>
                            </div>
                            <span style="font-size: 10px" class="text-danger">Only PDF JPEG PNG</span>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group label="Email" label-cols="3">
                            <b-form-input
                                    type="email"
                                    v-model="spouseInfo[index].email"
                                    :state="getInputState(spouseInfo[index].email)"
                                    placeholder="Email">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="showError(spouseInfo[index].email)">
                                Email name is required.
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group label="Mobile" label-cols="3">
                            <b-form-input
                                    v-model="spouseInfo[index].mobile"
                                    :state="getInputState(spouseInfo[index].mobile)"
                                    placeholder="Mobile">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="showError(spouseInfo[index].mobile)">
                                Mobile name is required.
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>

                    <div class="col-md-8">
                        <b-form-group label="Spouse Existence Status" label-cols="3">
                            <b-form-radio-group
                                    :id="`spouse-existence-${index}`"
                                    v-model="spouseInfo[index].existing"
                                    :options="spouseInfoOptions"
                                    :button-variant="spouseInfo[index].existing === 'false' ? 'outline-danger' : 'outline-success'"
                                    :name="`spouseExistence-${index}`"
                                    buttons
                            ></b-form-radio-group>
                        </b-form-group>
                    </div>

                    <div class="text-center mb-4">
                        <button class="btn btn-danger btn-md" @click="removeSpouse(index)"
                                v-if="spouseInfo.length > 1">REMOVE&nbsp;<span> <font-awesome-icon icon="minus"
                                                                                                    class="modal-icon text-white"/></span>
                        </button>
                    </div>
                </div>

                <div class="text-center mb-4">
                    <button @click="addSpouse" class="btn btn-success btn-md">
                        <span><font-awesome-icon icon="plus" class="modal-icon text-white"/>&nbsp;{{$t('ADD SPOUSE')}}</span>
                    </button>
                </div>
            </div>

            <!--            TODO: here is my spouse info end-->

            <!--            TODO: here is my Child info start-->

            <div class="col-md-12 heading mb-4">
                <h4 class="bg-success p-3 rounded text-white text-center fw-bold">{{$t("Children's Information")}}</h4>
                <b-form-group label-cols="3">
                    <b-form-checkbox
                            v-model="children_here"
                            value="accepted"
                            unchecked-value="not_accepted"
                    >
                        {{$t('If have any ( Children ) check this box.')}}
                    </b-form-checkbox>
                </b-form-group>
            </div>

            <div class="child-main" v-if="children_here == 'accepted' || this.childInfo.length > 0">
                <div v-for="(child, index) in childInfo" :key="index" class="row">
                    <div class="col-md-6">
                        <b-form-group label="Child Name">
                            <b-form-input
                                    :state="getInputState(childInfo[index].childName)"
                                    v-model="childInfo[index].childName"
                                    placeholder="Child Name"
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="showError(childInfo[index].childName)">
                                Child Name is required.
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label="Gender">
                            <b-form-select
                                    v-model="childInfo[index].genderId"
                                    :options="genderOptions"
                                    value-field="genderId"
                                    text-field="gender"
                                    disabled-field="notEnabled"
                            >
                                <option value="">-- Select One --</option>
                            </b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label="Profession">
                            <b-form-select
                                    v-model="childInfo[index].professionId"
                                    :options="professionOption"
                                    value-field="professionId"
                                    text-field="profession"
                                    disabled-field="notEnabled"
                            >
                                <option value="">-- Select One --</option>
                            </b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label="Nationality">
                            <b-form-select
                                    v-model="childInfo[index].nationalityId"
                                    :options="nationalityOptions"
                                    value-field="countryId"
                                    text-field="country"
                                    disabled-field="notEnabled"
                            >
                                <option value="">-- Select One --</option>
                            </b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label="Date Of Birth">
                            <b-form-input
                                    v-model="childInfo[index].dob"
                                    type="date"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label="NID/Passport No">
                            <b-form-input
                                    v-model="childInfo[index].nid"
                                    placeholder="NID/Passport No"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6" v-if="childInfo[index].nid">
                        <b-form-group
                                label="NID/Passport Document"
                                label-for="profile-photo"
                                class="profile-photo"
                                label-cols="3">
                            <div class="d-flex align-items-center">
                                <input
                                        type="file"
                                        ref="fileinput"
                                        name="profilePhoto"
                                        @change="childInfoNid(index, $event)"
                                        class="form-control form-control-md me-2"
                                        style="width: 90%;"/>
                                <button
                                        class="btn btn-success"
                                        @click="downloadFile(childInfo[index].nidPaperUrl, 'M_NID File')"
                                        v-if="childInfo[index].nidPaperUrl"
                                        style="white-space: nowrap;">
                                    <font-awesome-icon class="text-white" :icon="['fas', 'download']"/>
                                </button>
                            </div>

                            <span style="font-size: 10px" class="text-danger">Only PDF JPEG PNG</span>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group label="Email">
                            <b-form-input
                                    v-model="childInfo[index].email"
                                    type="email"
                                    placeholder="Email"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label="Mobile">
                            <b-form-input
                                    v-model="childInfo[index].mobile"
                                    placeholder="Mobile"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label="Child Existing Status">
                            <b-form-radio-group
                                    v-model="childInfo[index].existing"
                                    :options="childInfoOptions"
                                    :button-variant="childInfo[index].existing == 'false' ? 'outline-danger' : 'outline-success'"
                                    buttons
                            ></b-form-radio-group>
                        </b-form-group>
                    </div>

                    <!-- Remove Button -->
                    <div class="col-md-12 text-center" v-if="this.childInfo.length > 1">
                        <button @click="removeChild(index)" class="btn btn-danger btn-md">
                            REMOVE CHILD <span> &nbsp; <font-awesome-icon icon="minus"
                                                                          class="modal-icon text-white"/></span>
                        </button>
                    </div>
                </div>

                <div class="text-center mt-3 mb-4">
                    <button @click="addChild" class="btn btn-success btn-md">
                        <span> &nbsp; <font-awesome-icon icon="plus" class="modal-icon text-white"/></span>{{$t('ADD CHILDREN')}}
                    </button>
                </div>
            </div>

            <!--            TODO: here is my Child info end-->

            <!--            TODO: here is my Sibling info Start-->
            <div class="col-md-12 heading mb-4">
                <h4 class="bg-success p-3 rounded text-white text-center fw-bold">{{$t("SIBLINGS INFORMATION")}}</h4>
                <b-form-group
                        id="permanent_address"
                        label-cols="3"
                        label-for="permanent_address"
                >
                    <b-form-checkbox
                            class="text-center"
                            v-model="sibling_here"
                            name="permanent_address"
                            value="accepted"
                            unchecked-value="not_accepted"
                    >
                        {{$t('If have any ( Sibling ) check this box.')}}
                    </b-form-checkbox>
                </b-form-group>
            </div>
            <div class="sibling-main" v-if="sibling_here == 'accepted' || this.siblingInfo.length > 0">
                <div v-for="(sibling, index) in siblingInfo" :key="index" class="row">
                    <div class="col-md-6">
                        <b-form-group
                                id="sibling_name"
                                label-cols="3"
                                label="Sibling Name"
                                label-for="sibling_name"
                        >
                            <b-form-input
                                    type="text"
                                    v-model="siblingInfo[index].siblingName"
                                    class="form-control"
                                    placeholder="Sibling Name"
                                    name="sibling_name"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                                id="gender"
                                label-cols="3"
                                label="Gender"
                                label-for="gender"
                        >
                            <b-form-select
                                    v-model="siblingInfo[index].genderId"
                                    :options="genderOptions"
                                    class="mb-3"
                                    value-field="genderId"
                                    text-field="gender"
                                    disabled-field="notEnabled"
                            >
                                <option value="" selected>-- Select One --</option>
                            </b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                                id="profession"
                                label-cols="3"
                                label="Profession"
                                label-for="profession"
                        >
                            <b-form-select
                                    v-model="siblingInfo[index].professionId"
                                    :options="professionOption"
                                    class="mb-3"
                                    value-field="professionId"
                                    text-field="profession"
                                    disabled-field="notEnabled"

                            >
                                <option :value="null" selected>-- Select One --</option>
                            </b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                                id="Nationality"
                                label-cols="3"
                                label="Nationality"
                                label-for="nationality"
                        >
                            <b-form-select
                                    v-model="siblingInfo[index].nationalityId"
                                    :options="nationalityOptions"
                                    class="mb-3"
                                    value-field="countryId"
                                    text-field="country"
                                    disabled-field="notEnabled"
                            >
                                <option :value="null" selected>-- Select One --</option>
                            </b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                                id="date_of_birth"
                                label-cols="3"
                                label="Date Of Birth"
                                label-for="date_of_birth"
                        >
                            <b-form-input
                                    v-model="siblingInfo[index].dob"
                                    type="date"
                                    class="mb-3"
                            >
                            </b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                                id="gender"
                                label-cols="3"
                                label="NID/Passport No"
                                label-for="gender"
                        >
                            <b-form-input
                                    type="text"
                                    v-model="siblingInfo[index].nid"
                                    class="form-control mt-3"
                                    placeholder="NID/Passport No"
                                    name="NID"
                            >
                            </b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6" v-if="sibling.nid">
                        <b-form-group
                                label="NID/Passport Document"
                                label-for="profile-photo"
                                class="profile-photo"
                                label-cols="3">
                            <div class="d-flex align-items-center">
                                <input
                                        type="file"
                                        ref="fileinput"
                                        name="profilePhoto"
                                        @change="siblingAttachment(index, $event)"
                                        class="form-control form-control-md me-2"
                                        style="width: 90%"/>
                                <button
                                        class="btn btn-success"
                                        @click="downloadFile(siblingInfo[index].nidPaperUrl, 'Spouse Nid')"
                                        v-if="siblingInfo[index].nidPaperUrl"
                                        style="white-space: nowrap;">
                                    <font-awesome-icon class="text-white" :icon="['fas', 'download']"/>
                                </button>
                            </div>
                            <span style="font-size: 10px" class="text-danger">Only PDF JPEG PNG</span>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                                label="Email"
                                label-cols="3"
                                label-for="email"
                                class="requiredField"
                        >
                            <b-form-input
                                    id="email"
                                    type="email"
                                    v-model="siblingInfo[index].email"
                                    name="email"
                                    placeholder="Email"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                                label="Mobile"
                                label-cols="3"
                                label-for="mobile"
                                class="requiredField"
                        >
                            <b-form-input
                                    id="mobile"
                                    v-model="siblingInfo[index].mobile"
                                    name="mobile"
                                    placeholder="Mobile"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label="Sibling Existence Status" label-cols="3">
                            <b-form-radio-group
                                    :id="`sibling-existence-${index}`"
                                    v-model="siblingInfo[index].existing"
                                    :options="siblingInfoOptions"
                                    :button-variant="siblingInfo[index].existing === 'false' ? 'outline-danger' : 'outline-success'"
                                    :name="`siblingExistence-${index}`"
                                    buttons
                            ></b-form-radio-group>
                        </b-form-group>

                    </div>
                    <div class="col-md-12 text-center mt-2 mb-4" v-if="this.siblingInfo.length > 1">
                        <button @click="removeSibling(index)" class="btn btn-danger btn-md">
                            REMOVE<span> &nbsp; <font-awesome-icon icon="minus" class="modal-icon text-white"/></span>
                        </button>
                    </div>
                </div>
                <div class="text-center mb-4">
                    <button @click="addSibling" class="text-white btn btn-success btn-md">
                        <span class=""><font-awesome-icon icon="plus" class="modal-icon text-white"/>&nbsp;{{$t('ADD SIBLING')}}</span>
                    </button>
                </div>
            </div>
            <!--            TODO: here is my Sibling info end-->

        </div>
    </div>
</template>

<script>
    import apiRepository, {getMedia} from "@/services/ApiRepository";
    // import Fieldset from 'primevue/fieldset';
    import {toast} from 'vue3-toastify'


    export default {
        name: "Step-Three",
        props: ["formData"],
        // props: {
        //     formData: {
        //         type: Object,
        //         required: true
        //     }
        // },
        emits: ['update-spouse-info', 'update-child-info', 'update-sibling-info'],
        data() {
            return {
                children_here: "not_accepted",
                sibling_here: "not_accepted",
                professionOption: [],
                nationalityOptions: [],
                genderOptions: [],
                spouseInfo: this.formData.spouseInfo && this.formData.spouseInfo.length ? this.formData.spouseInfo : [
                    {
                        spouseName: "",
                        professionId: "",
                        nationalityId: "",
                        nid: "",
                        email: "",
                        mobile: "",
                        existing: "true",
                    }
                ],
                childInfo: this.formData.childInfo && this.formData.childInfo.length ? this.formData.childInfo : [
                    {
                        childId: '',
                        childName: '',
                        genderId: '',
                        professionId: '',
                        nationalityId: '',
                        dob: '',
                        nid: '',
                        nidPaperUrl: '',
                        mobile: '',
                        email: '',
                        existing: 'true',
                        userId: '',
                        nidFile: ''
                    }
                ],
                siblingInfo: this.formData.siblingInfo && this.formData.siblingInfo.length ? this.formData.siblingInfo : [
                    {
                        siblingId: "",
                        siblingName: "",
                        genderId: "",
                        professionId: "",
                        nationalityId: "",
                        nid: "",
                        nidPaperUrl: "",
                        whatsAppNumber: "",
                        dob: "",
                        email: "",
                        existing: "true",
                        socialMediaLink: "",
                        userId: "",
                        nidFile: ""
                    }
                ],


                spouseInfoOptions: [
                    {text: this.$t('Alive'), value: "true"},
                    {text: this.$t('Dead'), value: "false"},
                ],
                childInfoOptions: [
                    {text: this.$t('Alive'), value: "true"},
                    {text: this.$t('Dead'), value: "false"},
                ],
                siblingInfoOptions: [
                    {text: this.$t('Alive'), value: "true"},
                    {text: this.$t('Dead'), value: "false"},
                ],
            };
        },
        mounted() {
            this.countryData();
            this.professionData();
            this.genderData();
            this.fetchProfileData();
        },
        watch: {
            childInfo: {
                deep: true,
                handler(newVal) {
                    this.$emit('update-child-info', newVal);
                }
            },
            spouseInfo: {
                deep: true,
                handler(newVal) {
                    this.$emit('update-spouse-info', newVal);
                }
            },
            siblingInfo: {
                deep: true,
                handler(newVal) {
                    this.$emit('update-sibling-info', newVal);
                }
            },


            /*spouseInfo: {
                deep: true,
                handler(newVal) {
                    this.$emit("update-formData", {...this.formData, spouseInfo: newVal});
                }
            },

            childInfo: {
                deep: true,
                handler(newVal) {
                    this.$emit("update-formData", {...this.formData, childInfo: newVal});
                }
            },
            siblingInfo: {
                deep: true,
                handler(newVal) {
                    this.$emit("update-formData", {...this.formData, siblingInfo: newVal});
                }
            }*/
        },
        methods: {
            getInputState(value) {
                if (value === '') return false;
                if (typeof value === 'string') return value.trim().length > 0;
                return !!value;
            },
            showError(value) {
                return value === '' || (typeof value === 'string' && value.trim() === '');
            },

            spouseInfoNid(index, event) {
                const file = event.target.files[0];
                if (file) {
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        this.spouseInfo[index].spouseNIDFile = reader.result;
                    };
                }
            },
            childInfoNid(index, event) {
                const file = event.target.files[0];
                if (file) {
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        this.childInfo[index].nidFile = reader.result;
                    };
                }
            },
            siblingAttachment(index, event) {
                const file = event.target.files[0];
                if (file) {
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        this.siblingInfo[index].nidFile = reader.result;
                    };
                }
            },
            countryData() {
                apiRepository.getCountry().then((response) => {
                    if (response || response.data || response.data.data) {
                        this.nationalityOptions = response.data;
                    }
                });
            },
            professionData() {
                apiRepository.getProfession().then((response) => {
                    if (response || response.data || response.data.data) {
                        this.professionOption = response.data;
                    } else {
                        console.error("Invalid response structure:", response.data);
                    }
                })
                    .catch((error) => {
                        console.error("Error fetching profession data:", error);
                    });
            },
            genderData() {
                apiRepository.getGender().then((response) => {
                    if (response || response.data || response.data.data) {
                        this.genderOptions = response.data;
                    }
                });
            },
            addSpouse() {
                this.spouseInfo.push({
                    spouseName: '',
                    professionId: '',
                    nationalityId: '',
                    nid: '',
                    email: '',
                    mobile: '',
                    existing: ''
                });
            },
            removeSpouse(index) {
                if (this.spouseInfo.length > 1) {
                    this.spouseInfo.splice(index, 1);
                } else {
                    alert("You don't have remove last one!!")
                }
            },
            addChild() {
                this.childInfo.push({
                    childId: '',
                    childName: '',
                    genderId: '',
                    professionId: '',
                    nationalityId: '',
                    dob: '',
                    nid: '',
                    nidPaperUrl: '',
                    mobile: '',
                    email: '',
                    existing: '',
                    userId: '',
                    nidFile: ''
                });
            },
            removeChild(index) {
                if (this.childInfo.length > 1) {
                    this.childInfo.splice(index, 1);
                } else {
                    alert("You can't remove the last child entry!");
                }
            },
            addSibling() {
                this.siblingInfo.push({
                    siblingId: "",
                    siblingName: "",
                    genderId: "",
                    professionId: "",
                    nationalityId: "",
                    nid: "",
                    nidPaperUrl: "",
                    whatsAppNumber: "",
                    email: "",
                    existing: "",
                    socialMediaLink: "",
                    userId: "",
                    nidFile: ""
                });
            },

            removeSibling(index) {
                if (this.siblingInfo.length > 1) {
                    this.siblingInfo.splice(index, 1);
                } else {
                    alert("You can't remove the last sibling entry!");
                }
            },
            fetchProfileData() {
                try {
                    apiRepository.userDataGet().then((response) => {
                        if (response) {
                            this.spouseInfo = response.data.spouseInfo
                            this.childInfo = response.data.childInfo
                            this.siblingInfo = response.data.siblingInfo
                        } else {
                            console.error('Data not Found!!')
                        }
                    })
                } catch (e) {
                    toast.error('Invalid Request !', e)
                }
            },
            async downloadFile(url, filename) {
                // Normalize some MIME subtype extensions (optional)
                const specialMimeExtMap = {
                    jpeg: "jpg",
                    msword: "doc",
                    "vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
                    "vnd.ms-excel": "xls",
                    "vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
                    "vnd.ms-powerpoint": "ppt",
                    "vnd.openxmlformats-officedocument.presentationml.presentation": "pptx",
                    "x-7z-compressed": "7z"
                    // Add more if needed
                };

                try {
                    const response = await fetch(getMedia() + url);
                    if (!response.ok) {
                        throw new Error(`Failed to fetch file: ${response.status} ${response.statusText}`);
                    }

                    const data = await response.json();

                    // Decode base64 content
                    const byteCharacters = atob(data.content);
                    const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
                    const byteArray = new Uint8Array(byteNumbers);

                    // Determine correct content type
                    let contentType = data.contentType || "";
                    let fileExt = "";

                    if (contentType.includes('/')) {
                        // Extract subtype after '/'
                        fileExt = contentType.split('/')[1].split(';')[0].trim().toLowerCase();

                        // Normalize extension if needed
                        if (fileExt in specialMimeExtMap) {
                            fileExt = specialMimeExtMap[fileExt];
                        }
                    }

                    // If filename doesn't already end with this extension, append it
                    if (fileExt && !filename.toLowerCase().endsWith(`.${fileExt}`)) {
                        filename += `.${fileExt}`;
                    }

                    // Create Blob
                    const blob = new Blob([byteArray], {type: contentType || "application/octet-stream"});

                    // Trigger download
                    const blobUrl = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(blobUrl);

                } catch (error) {
                    console.error("Download failed:", error);
                }
            },

        },
    };
</script>

<style scoped>
    /* Add any scoped styles if needed */
</style>
